import { Platform } from 'react-native';

/**
 * The app's user-facing version, sent to the backend version gate on every
 * native request (X-App-Version) and used by the launch update-check.
 *
 * ⚠️ MUST be bumped in lockstep on every release with:
 *   - android/app/build.gradle  → versionName
 *   - ios CFBundleShortVersionString
 *   - package.json              → version
 * Kept as a hand-maintained constant to avoid a JSON-import / native build dep.
 */
export const APP_VERSION = '1.4.0';

/** Platform string the gate keys on. Only 'ios' / 'android' are ever gated. */
export const APP_PLATFORM = Platform.OS;
